import * as React from "react";
import {
    GridColumn,
    Grid,
    GRID_COL_INDEX_ATTRIBUTE,
} from "@progress/kendo-react-grid";
import { withState } from "./grid";
import { ColumnMenu } from "./columnMenu";
import Moment from "react-moment";
import { useTableKeyboardNavigation } from "@progress/kendo-react-data-tools";
import { Button, Modal, Tooltip } from "antd";
import store from "../../store";

const StatefullGrid = withState(Grid);
const CustomLockedCell = (props, customCell) => {
    const field = props.field || "";
    const value = props.dataItem[field];
    const navigationAttributes = useTableKeyboardNavigation(props.id);
    return (
        <td
            style={props.style}
            className={props.className}
            colSpan={props.colSpan}
            role={"gridcell"}
            aria-colindex={props.ariaColumnIndex}
            aria-selected={props.isSelected}
            {...{
                [GRID_COL_INDEX_ATTRIBUTE]: props.columnIndex,
            }}
            {...navigationAttributes}>
            {customCell ? customCell(props) : value}
        </td>
    );
};

class List extends React.Component {
    constructor(props) {
        super(props);
        this.eleRef = React.createRef();
        this.state = {
            columns: this.props?.columns || [],
            layoutHasChanged: false,
            dataState: {},
            loading: true,
            isBtnLoading: false,
            featureId: store.getState().permissions?.currentScreenTabId || store.getState().permissions?.currentScreenId,
            customerId: store.getState().userConfig?.userProfileInfo?.id,
            saveGridModalIsVisible: store.getState().saveGridModal?.saveGridModalIsVisible,
            username: store.getState().userConfig?.userProfileInfo?.userName
        };
        this.handleColumnReorder = this.handleColumnReorder.bind(this);
    }

    refreshGrid() {
        this.eleRef.current.refreshGrid();
    }

    renderDate = (props) => {
        if (props.dataItem[props.field]) {
            return (
                <td>
                    <Moment format="DD/MM/YYYY">
                        {this.convertUTCToLocalTime(props?.dataItem[props.field])}
                    </Moment>
                </td>
            );
        } else {
            return <td>{props.dataItem[props.field]}</td>;
        }
    };

    renderDateTime = (props) => {
        if (props.dataItem[props.field]) {
            return (
                <td>
                    <Moment format="DD/MM/YYYY hh:mm:ss A" globallocal="value">
                        {this.convertUTCToLocalTime(props?.dataItem[props.field])}
                    </Moment>
                </td>
            );
        } else {
            return <td>{props.dataItem[props.field]}</td>;
        }
    };

    convertUTCToLocalTime = (dateString) => {
        let date = new Date(dateString);
        const milliseconds = Date.UTC(
            date.getFullYear(),
            date.getMonth(),
            date.getDate(),
            date.getHours(),
            date.getMinutes(),
            date.getSeconds()
        );
        return new Date(milliseconds).toISOString();
    };

    renderNumber = () => {
        return (
            <td>
                {" "}
            </td>
        );
    };

    gridFilterData = (column) => {
        if (column.filterType === "date") {
            return column.isShowTime ? this.renderDateTime : this.renderDate;
        } else if (column.filterType === "number") {
            return this.renderNumber;
        } else if (column.filterType === "datetime") {
            return this.renderDateTime;
        }
        return null;
    };

    onColumnsApply = (columnsState) => {
        this.setState({
            columns: columnsState,
            layoutHasChanged: true
        });
    };

    resetToDefault = () => {
        const columnsFromProps = this.props.columns?.map((col, indx) => ({
            ...col, show: true, orderIndex: indx, originalIndex: indx
        }));
        const initialDataState = {
            filter: undefined,
            sort: undefined,
            skip: 0,
            take: this.props?.pSize || 10,
            group: []
        };
        this.setState({
            columns: columnsFromProps,
            dataState: initialDataState,
            layoutHasChanged: true
        });
        this.eleRef.current?.resetToDefault(initialDataState);
    };

    CustomOrGroupHeaderCell = (props, column) => {
        if (props.rowType === "groupHeader") return null;
        return column.locked
            ? CustomLockedCell(props, column.customCell)
            : column.customCell?.(props);
    };

    gridChildrenData = (column, indx) => {
        return (
            <GridColumn
                key={indx}
                locked={column.locked}
                columnMenu={
                    column.filter
                        ? (props) => (
                            <ColumnMenu
                                {...props}
                                columns={this.state.columns}
                                onColumnsApply={this.onColumnsApply}
                                resetToDefault={this.resetToDefault}
                            />
                        )
                        : null
                }
                field={column.field}
                title={column.title}
                width={column.width}
                cell={
                    (!column.locked && !column.customCell)
                        ? this.gridFilterData(column)
                        : (props) => this.CustomOrGroupHeaderCell(props, column)
                }
                filterable={!!column.filter}
                filter={column.filter ? (column.filterType || "text") : undefined}
                format="{0:#,0.##########}"
                reorderable={!column.locked}
                orderIndex={column.orderIndex}
                sortable={column.sortable === false ? false : true}
            />
        );
    };

    handleColumnReorder = (event) => {
        for (let i = 0; i < event.columns.length; i++) {
            if (event.columns[i].reorderable === true) {
                break;
            }
            if (event.columns[i].orderIndex !== i) {
                return;
            }
        }

        let columnsToSave = [];
        if (this.state.columns.length === event.columns.length) {
            columnsToSave = this.state.columns.map((col, i) => ({
                ...col,
                orderIndex: event.columns[i]?.orderIndex
            }));
        } else {
            let newArr = [];
            let toMinus = 0;
            for (let i in this.state.columns) {
                let colToPush;
                if (this.state.columns[i].show) {
                    colToPush = {
                        ...this.state.columns[i],
                        orderIndex: event.columns[i - toMinus]?.orderIndex
                    };
                } else {
                    colToPush = { ...this.state.columns[i] };
                    toMinus++;
                }
                newArr.push(colToPush);
            }
            newArr.sort((a, b) => a.orderIndex - b.orderIndex);
            newArr = newArr.map((column, indx) => ({
                ...column,
                orderIndex: indx
            }));
            newArr.sort((a, b) => a.originalIndex - b.originalIndex);
            columnsToSave = newArr;
        }

        this.setState({
            columns: columnsToSave,
            layoutHasChanged: true
        });
    };

    dataStateChangeHandler = (dataState) => {
        const pageSizeToDisplay = dataState.take || "All";
        this.setState({
            dataState: { ...dataState, take: pageSizeToDisplay },
            layoutHasChanged: true
        });
    };

    onSaveHandler = async () => {
        this.setState({ isBtnLoading: true });
    };

    render() {
        const { url, isABpCall = false } = this.props;

        return (
            <div>
                <Modal
                    open={this.state.saveGridModalIsVisible}
                    onCancel={this.cancelHandler}
                    title={'Save Grid Layout?'}
                    maskClosable={false}
                    closeIcon={
                        <Tooltip title="Close">
                            <span className="icon close c-pointer" />
                        </Tooltip>
                    }
                    footer={[
                        <Button
                            key="cancel"
                            type="primary"
                            className="primary-btn cancel-btn"
                        >
                            Cancel
                        </Button>,
                        <Button
                            key="save"
                            type="primary"
                            className="primary-btn ml-8"
                            onClick={this.onSaveHandler}
                            loading={this.state.isBtnLoading}
                            disabled={!this.state.layoutHasChanged}
                        >
                            Save
                        </Button>
                    ]}
                >
                    <p className="fs-16 mb-0">
                        {this.state.layoutHasChanged
                            ? 'Are you sure you want to save the layout?'
                            : 'Layout has not been edited'}
                    </p>
                </Modal>

                <StatefullGrid
                    reorderable={!this.props.columnsIsNotReorderable}
                    groupable={false}
                    cellRender={this.cellRender}
                    onColumnReorder={this.handleColumnReorder}
                    url={url}
                    ref={this.eleRef}
                    showExcelExport={this.props.showExcelExport}
                    callback={this.callback}
                    {...this.props}
                    isABpCall={isABpCall}
                    getDataStateFromChild={this.dataStateChangeHandler}
                    dataState={this.state.dataState}
                >
                    {(this.props?.columns || []).map((column, indx) =>
                        this.gridChildrenData(column, indx)
                    )}
                </StatefullGrid>
            </div>
        );
    }
}

export default List;
